import { FC } from 'react';
import { DpCatalogEntryCarouselHeader } from '@/components/blocks/DpLibrary/DpCatalogEntryCarouselHeader';
import { CatalogEntryCarousel } from '@/components/content/CatalogEntryRecommendation/parts/CatalogEntryCarousel';
import { cardSkeletonContainerMapper } from '@/components/content/CatalogEntryRecommendation';

const skeletonSlide = cardSkeletonContainerMapper(
	Array.from({ length: 15 }).map((_, index) => `skeleton_${index}`)
).map((slide) => slide.card);

export const CatalogEntryIARecommendationSkeleton: FC<{
	id?: string;
	title?: string;
}> = ({ title, id = 'catalogEntryRecommendationIA' }) => (
	<>
		{title ? <DpCatalogEntryCarouselHeader title={title} /> : null}
		<CatalogEntryCarousel slides={skeletonSlide} id={id} />;
	</>
);
